(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.MapsUploadService = (function(superClass) {
    extend(MapsUploadService, superClass);

    function MapsUploadService(http, modal1, typeHelper) {
      this.http = http;
      this.modal = modal1;
      this.typeHelper = typeHelper;
      this.getInputFilesProcessingStatus = bind(this.getInputFilesProcessingStatus, this);
      this.replaceDuplicateFiles = bind(this.replaceDuplicateFiles, this);
      this.queueRemoval = bind(this.queueRemoval, this);
      this.showInvalidShapefileDialog = bind(this.showInvalidShapefileDialog, this);
      this.showDuplicateFileDialog = bind(this.showDuplicateFileDialog, this);
      this.finalizeUpload = bind(this.finalizeUpload, this);
      this.processUploads = bind(this.processUploads, this);
      this.existingFiles = bind(this.existingFiles, this);
      this.getTypeHelp = bind(this.getTypeHelp, this);
      this.formatExtension = bind(this.formatExtension, this);
      this.extractFormat = bind(this.extractFormat, this);
      this.getFormatDescription = bind(this.getFormatDescription, this);
      this.deleteCsqDirectory = bind(this.deleteCsqDirectory, this);
      this.clearUpload = bind(this.clearUpload, this);
      this.deleteTempFile = bind(this.deleteTempFile, this);
      this.getFileTypes = bind(this.getFileTypes, this);
      this.getProducts = bind(this.getProducts, this);
      this.getMakes = bind(this.getMakes, this);
      this.getTypes = bind(this.getTypes, this);
      this.setFileExtension = bind(this.setFileExtension, this);
      this.getFileExtension = bind(this.getFileExtension, this);
      this.options = null;
      this.file_extension = null;
      this.file_list = null;
      this.csq_id = null;
      this.validFiles = false;
    }

    MapsUploadService.prototype.getFileExtension = function() {
      return this.formatExtension(this.file_extension);
    };

    MapsUploadService.prototype.setFileExtension = function(val) {
      if (val != null) {
        return this.file_extension = val;
      }
    };

    MapsUploadService.prototype.getTypes = function() {
      return this.http.post('backend/grower/maps-upload/get-types');
    };

    MapsUploadService.prototype.getMakes = function(upload_type) {
      return this.http.post('backend/grower/maps-upload/get-makes', {
        upload_type: upload_type
      });
    };

    MapsUploadService.prototype.getProducts = function(upload_type, make_id) {
      return this.http.post('backend/grower/maps-upload/get-products', {
        upload_type: upload_type,
        make_id: make_id
      });
    };

    MapsUploadService.prototype.getFileTypes = function(model_id) {
      return this.http.post('backend/grower/maps-upload/get-file-types', {
        model_id: model_id
      });
    };

    MapsUploadService.prototype.deleteTempFile = function(file) {
      var base_name, index, object, ref;
      base_name = file[0].name.split('.')[0];
      ref = this.file_list;
      for (index in ref) {
        object = ref[index];
        if (object.file.split('.')[0] === base_name) {
          _.remove(this.file_list, object);
        }
      }
      return this.http.post('backend/grower/upload-controller/delete-temp-file', {
        name: file[0].name,
        csq_id: this.csq_id
      });
    };

    MapsUploadService.prototype.clearUpload = function() {
      return this.http.post('backend/grower/upload-controller/clear-upload');
    };

    MapsUploadService.prototype.deleteCsqDirectory = function() {
      return this.http.post('backend/grower/upload-controller/delete-csq-directory', {
        csq_id: this.csq_id
      }).then((function(_this) {
        return function() {
          return _this.csq_id = null;
        };
      })(this));
    };

    MapsUploadService.prototype.getFormatDescription = function(id) {
      return this.http.post('backend/grower/maps-upload/get-format-description', {
        id: id
      });
    };

    MapsUploadService.prototype.extractFormat = function(name) {
      return name.split(' (')[0];
    };

    MapsUploadService.prototype.formatExtension = function(extension) {
      if (extension === null) {
        return null;
      }
      return extension.replace(/\./g, '').replace(/\s/g, '') + ',zip';
    };

    MapsUploadService.prototype.getTypeHelp = function(type) {
      return this.typeHelper.showTypeHelp(type);
    };

    MapsUploadService.prototype.existingFiles = function() {
      return this.http.post('backend/grower/upload-controller/existing-files');
    };

    MapsUploadService.prototype.processUploads = function(params) {
      return this.http.post('backend/grower/upload-controller/process-uploads', {
        params: params
      });
    };

    MapsUploadService.prototype.finalizeUpload = function() {
      return this.http.post('backend/grower/upload-controller/finalize-upload', {
        file_list: this.file_list,
        options: this.options,
        csq_id: this.csq_id
      });
    };

    MapsUploadService.prototype.showDuplicateFileDialog = function(duplicate_files) {
      var modal;
      return modal = this.modal.open({
        windowClass: 'modal-width',
        templateUrl: 'backend/grower/maps-upload/duplicate-file-dialog',
        controller: 'MapsUpload.Controllers.DuplicateFileDialogController',
        resolve: {
          data: (function(_this) {
            return function() {
              return {
                'files': duplicate_files
              };
            };
          })(this)
        }
      });
    };

    MapsUploadService.prototype.showInvalidShapefileDialog = function(invalid_files) {
      var modal;
      return modal = this.modal.open({
        windowClass: 'modal-width',
        templateUrl: 'backend/grower/maps-upload/invalid-shapefile-dialog',
        controller: 'MapsUpload.Controllers.InvalidShapefileDialogController',
        resolve: {
          data: (function(_this) {
            return function() {
              return {
                'data': invalid_files
              };
            };
          })(this)
        }
      });
    };

    MapsUploadService.prototype.queueRemoval = function(file_groups) {
      var base_name, file, id, index, queue_file, ref, removal_ids, results;
      removal_ids = [];
      for (index in file_groups) {
        file = file_groups[index];
        base_name = file.filename.split('.')[0];
        ref = this.uploader.files;
        for (index in ref) {
          queue_file = ref[index];
          if (queue_file.name.indexOf(base_name) !== -1) {
            removal_ids.push(queue_file.id);
          }
        }
      }
      results = [];
      for (index in removal_ids) {
        id = removal_ids[index];
        $("#" + id).remove();
        results.push(this.uploader.removeFile(id));
      }
      return results;
    };

    MapsUploadService.prototype.replaceDuplicateFiles = function(file_list) {
      return this.http.post('backend/grower/upload-controller/replace-duplicate-files', {
        file_list: file_list
      });
    };

    MapsUploadService.prototype.getInputFilesProcessingStatus = function(input_files_ids) {
      return this.http.post('backend/grower/upload-controller/get-input-file-processing-status', {
        input_files_ids: input_files_ids
      });
    };

    return MapsUploadService;

  })(Service);

}).call(this);
